/* global google */
import React from 'react'
import InputController from '../../../../../Global/InputController'
import { Title } from '../StepReport'
import { defaultCenterGoogleMap } from './helpers/const'
import GoogleMapComponentV3 from '../../../../../Global/GoogleMapComponentV3'

const Location = ({
  setDataAddress,
  dataAddress,
  disabled,
  cols = 'col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6',
  control,
}) => {
  const handleChangeMap = (data) => {
    setDataAddress(data)
  }

  return (
    <>
      {!disabled && (
        <div className={cols}>
          <Title text="Mapa" />
          <GoogleMapComponentV3
            mapContainerStyle={{ width: '100%', height: '200px' }}
            optionsGoogleMap={{ disableDefaultUI: true, zoomControl: true }}
            defaultCenterGoogleMap={defaultCenterGoogleMap}
            disabled={disabled}
            onChange={handleChangeMap}
            dataEdit={dataAddress?.edit ? dataAddress : false}
          />

          <div className="row">
            {/* <div className="mb-2 col-12 mb-3" style={{ display: 'none' }}>
              <InputController
                label="Direccion a guardar"
                name="address_full"
                control={control}
                inputType="textarea"
                rows={2}
                readOnly
              />
            </div> */}
            {dataAddress?.colony_name && (
              <div className="mb-2 col-12 mb-3">
                <label htmlFor="">Colonia</label>
                <input
                  disabled={true}
                  type="text"
                  className="form-control rounded-2"
                  autoComplete="off"
                  value={dataAddress?.colony_name}
                />
              </div>
            )}
            <div className="mb-2 col-12 mb-3 mt-3">
              <InputController
                disabled={disabled}
                label="Referencias de la dirección"
                name="address_reference"
                control={control}
                type="text"
              />
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default React.memo(Location)
